<template>
    <div class="rate-referred">
        <div v-if="!areRatingsEntered" class="rating-description">
            <p>{{ $t('pages.referrals.update.rate_referred.rate_on_scale') }}</p>
        </div>
        <ratings-enter
            v-show="!areRatingsEntered"
            :ratings="ratings"
            :allowBackButton="true"
            @ratings-entered="ratingsEntered"
        ></ratings-enter>
        <ratings-summary
            v-if="areRatingsEntered"
            :ratingsWithGrades="ratings"
            :summaryText="summaryText"
            :maxGrade="5"
            :numberedList="false"
            :highlightedRatingKey="'overallSatisfaction'"
        ></ratings-summary>
        <div class="spacer">&nbsp;</div>
        <common-button
            v-if="areRatingsEntered"
            :label="$t('pages.referrals.update.rate_referred.buttons.back_to_referrals')"
            type="primary"
            size="large"
            @click="redirectToIndexPage"
        ></common-button>
    </div>
</template>

<script>
    import { composeDisplayName } from 'components/common/CommonUserName'
    import RatingsEnter from 'components/page-elements/ratings/RatingsEnter'
    import RatingsSummary from 'components/page-elements/ratings/RatingsSummary'
    import ReferralsAPI from 'api/ReferralsAPI'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        components: {
            RatingsEnter,
            RatingsSummary,
        },

        props: {
            referral: { type: Object, required: true },
        },

        data() {
            return {
                maxGrade: 5,
                ratings: [],
                grades: [],
                areRatingsEntered: false,
                areRatingsSaved: false,
            }
        },

        computed: {
            referredToName() {
                if (this.referral.practice.practiceType === PracticeTypeEnum.ANCILLARY) {
                    return this.referral.practice.name
                } else {
                    return composeDisplayName(this.referral.toUser)
                }
            },

            summaryText() {
                return `${this.$t('pages.referrals.update.rate_referred.thank_you_for_rating', {
                    referredToName: this.referredToName || '',
                    designation: this.referral.toUser.designation || '',
                })}!`
            },
        },

        methods: {
            ratingsEntered(grades) {
                this.areRatingsEntered = true
                this.grades = grades

                this.ratings.forEach((rating) => {
                    rating.grade = this.grades[rating.key]
                })

                ReferralsAPI.updatePhysicianReview(this.referral.id, this.referral.practice.practiceType, this.grades).then(
                    () => {},
                )
            },

            redirectToIndexPage() {
                let type = this.$route.params.type || 'received'
                this.$router.push({
                    name: `referrals.${type}.referrals`,
                    params: {
                        type: type,
                    },
                })
            },
        },

        mounted() {
            if (this.referral.practice.practiceType === PracticeTypeEnum.ANCILLARY) {
                this.ratings = [
                    {
                        text: this.$t('pages.referrals.update.rate_referred.ratings.ancillary.qualityOfTest'),
                        key: 'qualityOfTest',
                    },
                    {
                        text: this.$t('pages.referrals.update.rate_referred.ratings.ancillary.qualityOfTheReport'),
                        key: 'qualityOfTheReport',
                    },
                    {
                        text: this.$t('pages.referrals.update.rate_referred.ratings.ancillary.patientExperience'),
                        key: 'patientExperience',
                    },
                    {
                        text: this.$t('pages.referrals.update.rate_referred.ratings.ancillary.reportReceivedOnTime'),
                        key: 'reportReceivedOnTime',
                    },
                    {
                        text: this.$t('pages.referrals.update.rate_referred.ratings.ancillary.overallSatisfaction'),
                        key: 'overallSatisfaction',
                    },
                ]
            } else {
                this.ratings = [
                    {
                        text: this.$t('pages.referrals.update.rate_referred.ratings.physician.professionalism'),
                        key: 'professionalism',
                    },
                    {
                        text: this.$t('pages.referrals.update.rate_referred.ratings.physician.fundOfKnowledge'),
                        key: 'fundOfKnowledge',
                    },
                    {
                        text: this.$t('pages.referrals.update.rate_referred.ratings.physician.patientCare'),
                        key: 'patientCare',
                    },
                    {
                        text: this.$t('pages.referrals.update.rate_referred.ratings.physician.receiptOfConsultationNote'),
                        key: 'receiptOfConsultationNote',
                    },
                    {
                        text: this.$t('pages.referrals.update.rate_referred.ratings.physician.overallSatisfaction'),
                        key: 'overallSatisfaction',
                    },
                ]
            }
        },
    }
</script>

<style scoped>
    .rate-referred {
        text-align: center;
    }
    .rating-description {
        margin: 20px 0px;
    }
    .spacer {
        margin-top: 20px;
    }
</style>
